module.exports = __webpack_public_path__ + "54cf98f5/img/splash-icon.07a7c465.svg";